import { enqueueSnackbar } from 'notistack';

import { formatErrorMessage } from './api/errors.ts';

export const showSnackbarError = (message: string): void => {
  enqueueSnackbar(formatErrorMessage(message), {
    variant: 'error',
  });
};
